// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__+Z-E2","load3":"Spinner_load3__DP+ua"};